/**
 * @file コンポーネント：フル動画ページ機器広告ボタン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnPushDataLayerGtm } from "~/src/functions/common";
import { fnSendEventHubspot } from "~/src/functions/hubspot";

// コンポーネントを返す
export const ButtonAd = (props) => {
    /**
     * 機器広告ボタンクリック処理
     */
    const fnOnClickDetail = (e) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        // 機器広告ポップアップを開く
        props.setIsOpenPopupAd(true);
        // 機器広告取得リクエスト
        const api = "/api/AdOperationRequests/add";
        const options = {
            body: JSON.stringify({ AdOperationId: props.adOperationId }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "POST",
        };
        fetch(api, options);
        // HubSpotにイベントを送信
        fnSendEventHubspot({
            name: "pe21169348_ad_detail",
            properties: {
                ad_detail_click: null,
            },
        });
        // Google Tag Manager カスタムイベントトリガー
        fnPushDataLayerGtm({
            event: "AdOperationClick",
            operationId: window.atob(props.operationId),
            userId: window.dataUser.userId,
        });
    };

    // Presenterに渡す
    return <Presenter {...props} fnOnClickDetail={fnOnClickDetail} />;
};
